import { ComponentProps, FC, useCallback, useEffect } from "react"
import { districtAddApi } from "src/domain/api/district/districtAddApi"
import { District } from "../../../../domain/entities/district"
import { useAuth, useStateListApi } from "../../../../domain/hooks"
import { FormikOnSubmit } from "../../../../utils/types"
import { DistrictAddDrawerFormView } from "./DistrictAddDrawerFormView"
import { IDistrictAddFormFields } from "./IDistrictAddFormFields"

interface Props
	extends Omit<
		ComponentProps<typeof DistrictAddDrawerFormView>,
		"handleSubmit" | "stateList"
	> {
	onSuccess: (district: District) => void
}

export const DistrictAddDrawerFormController: FC<Props> = ({ onSuccess, ...rest }) => {
	const { token } = useAuth()

	const handleSubmit = useCallback<FormikOnSubmit<IDistrictAddFormFields>>(
		async (values, { setErrors }) => {
			try {
				const district = await districtAddApi(values, token)
				onSuccess(district)
				rest.onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({
					name: {
						en: message,
					},
				})
			}
		},
		[onSuccess, rest, token],
	)

	const { fetchStateList, stateList } = useStateListApi()

	useEffect(() => {
		fetchStateList()
	}, [fetchStateList])

	return (
		<DistrictAddDrawerFormView
			handleSubmit={handleSubmit}
			stateList={stateList}
			{...rest}
		/>
	)
}
